import { AlertCircle, Loader2 } from "lucide-react";
import { DashboardLayout } from "@/components/DashboardLayout";
import { Button } from "@/components/ui/button";

// What a flag-gated admin page shows instead of itself while useModuleAccess
// is still deciding, or can't decide. See src/hooks/useModuleAccess.tsx.

export function ModuleAccessLoading() {
  return (
    <DashboardLayout>
      <div className="flex justify-center py-12">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    </DashboardLayout>
  );
}

export function ModuleAccessError({ label }: { label: string }) {
  return (
    <DashboardLayout>
      <div className="flex flex-col items-center gap-3 py-12 text-center">
        <AlertCircle className="h-6 w-6 text-destructive" />
        <p className="text-sm text-muted-foreground">
          Couldn&apos;t load feature settings, so this page can&apos;t check whether {label} is on for you.
        </p>
        <Button variant="outline" size="sm" onClick={() => window.location.reload()}>
          Reload
        </Button>
      </div>
    </DashboardLayout>
  );
}
